let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("afuPY")).then(() => parcelRequire('8KM8a'));